
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[productId]/reviews",
      function () {
        return require("private-next-pages/products/[productId]/reviews.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[productId]/reviews"])
      });
    }
  